import { render, staticRenderFns } from "./publish-weak-point.vue?vue&type=template&id=145a23b4&scoped=true"
import script from "./publish-weak-point.vue?vue&type=script&lang=js"
export * from "./publish-weak-point.vue?vue&type=script&lang=js"
import style0 from "./publish-weak-point.vue?vue&type=style&index=0&id=145a23b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145a23b4",
  null
  
)

export default component.exports